import { useState } from 'react';

type TopicModal = 'edit' | 'archive' | 'delete' | null;

export function useTopicMenuAction() {
  const [activeModal, setActiveModal] = useState<TopicModal>(null);

  return {
    activeModal,
    handleOpenEditModal: () => setActiveModal('edit'),
    handleOpenArchiveModal: () => setActiveModal('archive'),
    handleOpenDeleteModal: () => setActiveModal('delete'),
    handleCloseModal: () => setActiveModal(null),
  };
}
